import { render } from "./Paginator.vue?vue&type=template&id=2abbd9f6"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=2abbd9f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__